import React, { ReactNode, useState } from 'react';
import { defaultFilters, FiltersContext } from './context';
import { FiltersType } from './types';

type FiltersContextProviderProps = {
  children: ReactNode;
};

export const FiltersContextProvider = ({ children }: FiltersContextProviderProps) => {
  const [filters, setFilters] = useState<FiltersType>(defaultFilters);
  const handleSetFilters = (value: FiltersType) => {
    setFilters((prev) => ({ ...prev, ...value }));
  };

  return (
    <FiltersContext.Provider value={{ filters, handleSetFilters }}>
      {children}
    </FiltersContext.Provider>
  );
};
